export default __webpack_public_path__ + "static/media/profile-img.a6fc5b9e.jpg";